module.exports = __webpack_public_path__ + "static/globuli_bw-984bc45afcbebcccb85549bf8016c529.jpg";